import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const saveContractsCall = createApi('api/cd/contracts/modify', 'PUT');

const SaveContracts = createSlice({
  name: 'SaveContracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveContractsCall.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveContractsCall.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveContractsCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveContracts.reducer;